var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M8.975 4.025a.75.75 0 0 1 0 1.06L4.81 9.25H17a.75.75 0 0 1 0 1.5H4.81l4.165 4.164a.75.75 0 0 1-1.06 1.06L2.47 10.53a.75.75 0 0 1 0-1.06l5.444-5.445a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;